<div *ngIf="hasDelta()" class="crm-delta-banner">
  <div *ngIf="!isFirstNote()"><span class="bold">{{ "CRM.CRM_SNAPSHOT.SONAR_UPDATE" | translate }} | </span>{{ this.createdDate.toLocaleDateString() }} - <span [innerHTML]="deltaString"></span></div>
  <div *ngIf="isFirstNote()"><span class="bold">{{ "CRM.CRM_SNAPSHOT.SONAR_ACTIVE" | translate }} | </span>{{ this.createdDate.toLocaleDateString() }}</div>
</div>
<div class="row pt-2">
  <div class="h-scrollable-wrapper">
    <div class="h-scrollable info-container">
      <table class="mr-md-auto">
        <tr>
          <td class="bold">{{ "CRM.STATUS" | translate }}:<span>{{ snapshot.status && snapshot.status.length > 0 ? statusLabels[snapshot.status] : '-' }}</span></td>
          <td></td>
          <td class="bold">{{ "CRM.ETAKI" | translate | uppercase }}:<span>{{ snapshot.etaki && snapshot.etaki.length > 0 && crmStatusService.hasEtakiStatus(snapshot) ? snapshot.etaki : '-' }}</span></td>
          <td></td>
          <td class="bold">{{ "CRM.COURTSHIP" | translate }}:<span>{{ snapshot.courtship && snapshot.courtship.length > 0 ? courtshipLabels[snapshot.courtship] : '-' }}</span></td>
          <td></td>
        </tr>
        <tr>
          <td class="bold">{{ "CRM.STORM" | translate }}:<span>{{ snapshot.storm && snapshot.storm.length > 0 ? stormLabels[snapshot.storm] : '-' }}</span></td>
          <td></td>
          <td class="bold">{{ "CRM.SILENCED_UNTIL" | translate }}:<span>{{ snapshot.silencedUntil && snapshot.silencedUntil.length > 0 ? snapshot.silencedUntil : '-' }}</span></td>
          <td></td>
        </tr>
      </table>
    </div>
  </div>
</div>
